/**
 * Une seule relecture : le 424 de live-api suit une attribution A/B non publiée, et la lecture
 * suivante renvoie la variante déjà retenue.
 */
export const OFFER_ASSIGNMENT_RETRY_DELAYS_MS: readonly number[] = [300];

/** Au-delà, l'offre est lue sans cookie de profil plutôt que d'attendre un échange lent. */
export const PROFILE_COOKIE_MAX_WAIT_MS = 1000;

/** Attend `promise` au plus `timeoutMs`, sans jamais échouer. */
export function waitAtMost(
  promise: Promise<unknown>,
  timeoutMs: number,
  schedule: (callback: () => void, delayMs: number) => unknown = setTimeout,
): Promise<void> {
  return new Promise((resolve) => {
    schedule(resolve, timeoutMs);
    promise.then(
      () => resolve(),
      () => resolve(),
    );
  });
}
